export default __webpack_public_path__ + "7a66d62e55b1d2204ae4707efb6f763c.jpg";